
import clsx from 'clsx'
import {range, chunk} from 'lodash'
import React from 'react'
import {Link} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

import {isEmpty} from '../../../helpers/utils'
import QuestionLink, {QuestionLinkDummy} from './QuestionLink'

const useStyles = makeStyles(sectionStyles)

export default function Section ({index, section, sections, context}) {

  const classes = useStyles()

  const {translate} = context
  const {questions = []} = section

  const title = isEmpty(section.title) ? `${translate('section')} ${index + 1}` : section.title

  const chunkSize = 4
  const questionRows = chunk(questions.map((question, index) => (<QuestionLink key={question.id} {...{index, section, question, context, sections}}/>)), chunkSize)

  const addDummies = row => {
    const missing = chunkSize - row.length
    const newRow = missing == 0 ? row : row.concat(range(missing).map((_,index) => (<QuestionLinkDummy key={row.length + index} />)))
    return newRow
  }

  const sectionLink = context.link({sectionId: section.id, questionId: undefined})

  const selected = section.id == context.sectionId && !context.questionId

  function handleClick (e) {
    selected && e.preventDefault()
  }

  return (
    <Box className={classes.root}>
      <Link className={clsx(classes.title, {selected})} onClick={handleClick} to={sectionLink}>
        {title}
      </Link>
      <Box className={classes.questions}>
        {questionRows.map((row, index) => (
          <Box key={index} className={classes.questionRow}>
            {addDummies(row)}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export function sectionStyles (theme) {
  return {
    title: {
      display: 'flex',
      padding: 10,
      textDecoration: 'none',
      color: '#5c6fcd',
      fontSize: '11pt',
      borderTop: 'solid 1px #e1e5e8',
      borderBottom: 'solid 1px #e1e5e8',
      borderLeft: 'solid 4px #577ee3',
      backgroundColor: '#fff7f3',
      "&.selected": {
        backgroundColor: '#577ee3',
        color: '#fff',
        cursor: 'default'
      }
    },
    questions: {
      display: 'flex',
      flexDirection: 'column',
      padding: '10px 5px',
    },
    questionRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 10,
    }
  }
}
